import React from 'react';
import ProductsHero from '../components/products/ProductsHero';
import FeaturedProducts from '../components/products/FeaturedProducts';
import ProductCategories from '../components/products/ProductCategories';
import FeaturesComparison from '../components/products/FeaturesComparison';
import ProductsCTA from '../components/products/ProductsCTA';

const Products = () => {
  return (
    <div>
      <ProductsHero />
      <ProductCategories />
      <FeaturedProducts />
      <FeaturesComparison />
      <ProductsCTA />
    </div>
  );
};

export default Products;